import { Plus } from "react-bootstrap-icons";

//App
import { NewButtonProps } from "../../../types";
import Button from "../VFX-UI/Button/Button";
import useButtonStyles from "./styles";

const NewButton = (props: NewButtonProps) => {
  const { style, toggleNewViewHandler } = props;
  const buttonStyles = useButtonStyles();

  return (
      <Button style={{ ...buttonStyles.newButton, ...style }} onClick={toggleNewViewHandler} >
          <Plus style={buttonStyles.newIcon} />
          <span style={buttonStyles.iconText}>New</span>
    </Button>
  );
};

export default NewButton;
